import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { NavbarColorDirective } from "@app/shared/navbar-color.directive";
import { TranslateModule } from "@ngx-translate/core";
import { InlineSVGModule } from "ng-inline-svg-w";
import { navbarColor } from "./book.component";

@Component({
  selector: "app-book-missing",
  templateUrl: "./book.missing.component.html",
  styleUrls: ["./book.component.scss"],
  standalone: true,
  imports: [NavbarColorDirective, RouterLink, InlineSVGModule, TranslateModule],
})
export class BookMissingComponent {
  navbarColor = navbarColor;
}
